// extracted by mini-css-extract-plugin
export default {"Trigger":"linked-pr-list-module__Trigger--BaeGt","Number":"linked-pr-list-module__Number--ZuOKt"};